<template>
  <v-dialog
    :model-value="dialog && mode === 'quick'"
    max-width="700px"
    @update:model-value="onDialogChange"
  >
    <v-card>
      <v-card-title class="text-h5 custom-card-header">
        Whale Details
        <v-btn
          icon
          variant="text"
          class="to-the-right"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <whale-profile-view :whale="whale" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close">
          <v-icon>mdi-close</v-icon>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WhaleProfileView from "@/components/whale/WhaleProfileView.vue";

export default {
  components: {
    WhaleProfileView,
  },
  computed: {
    ...mapGetters({
      whale: "whale/view/whale",
      mode: "whale/view/mode",
      dialog: "whale/view/dialog",
    }),
  },
  methods: {
    ...mapActions({
      close: "whale/view/close",
    }),
    onDialogChange(value) {
      if (!value) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.to-the-right {
  float: right;
}
</style>
